import { createDecorator, SubmitlessForm } from 'components/form'
import { Decorator } from 'final-form'
import { MChatRiscoEnum } from 'graphql/types.generated'
import React, { MutableRefObject, useRef } from 'react'

import { consultaSeguimentoCalculator } from '../calculator-consultaSeguimento'
import { ConsultaSeguimentoModal } from '../consulta-seguimento-modal/ConsultaSeguimentoModal'
import { ConsultaSeguimentoFieldModel, MChatPerguntaPrincipal } from '../model-consultaSeguimento'
import { validatorConsultaSeguimento } from '../validator-consultaSeguimento'
import { getAplicacaoInitialValues } from './utils-consultaSeguimentoAplicacao'

interface ConsultaSeguimentoAplicacaoFormProps {
  aplicarButtonRef: React.RefObject<HTMLButtonElement>
  mChatPerguntasFalhas: ReadonlyArray<MChatPerguntaPrincipal>
  mChatRisco: MChatRiscoEnum | undefined
  valueInCache: ConsultaSeguimentoFieldModel | undefined
  isConsultaSeguimentoDesatualizada: boolean
  onSubmit: (values: ConsultaSeguimentoFieldModel) => void
}

const decorator = createDecorator(...consultaSeguimentoCalculator) as Decorator<ConsultaSeguimentoFieldModel>

export function ConsultaSeguimentoAplicacaoForm(props: Readonly<ConsultaSeguimentoAplicacaoFormProps>) {
  const {
    aplicarButtonRef,
    mChatPerguntasFalhas,
    mChatRisco,
    valueInCache,
    isConsultaSeguimentoDesatualizada,
    onSubmit,
  } = props

  const { aplicacao, perguntasSelecionadas } = getAplicacaoInitialValues(
    valueInCache,
    mChatPerguntasFalhas,
    isConsultaSeguimentoDesatualizada
  )

  const initialValues: MutableRefObject<ConsultaSeguimentoFieldModel> = useRef({
    perguntasSelecionadas,
    aplicacao,
  })

  const renderForm = () => (
    <ConsultaSeguimentoModal
      valueInCache={valueInCache}
      isConsultaSeguimentoDesatualizada={isConsultaSeguimentoDesatualizada}
      mChatRisco={mChatRisco}
      mChatPerguntasFalhas={mChatPerguntasFalhas}
      aplicarButtonRef={aplicarButtonRef}
      onSave={onSubmit}
    />
  )

  return (
    <SubmitlessForm<ConsultaSeguimentoFieldModel>
      initialValues={initialValues.current}
      render={renderForm}
      validate={validatorConsultaSeguimento}
      decorators={[decorator]}
    />
  )
}
